import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Blocks, Lines, NodeCircles, NodeCirclesExtended, RowLabels } from '..'
import { IOrgStageCoordsGetterOutput } from '../../functions/getOrgStages-1'

/// functions
/// types
/// components

interface StagesProps extends IOrgStageCoordsGetterOutput { }

export const Stages: React.FC<StagesProps> = observer((dotsCoords) => {


    
    return (<>
        <RowLabels {...dotsCoords} />
        <Blocks {...dotsCoords} />
        <Lines {...dotsCoords} />
        <NodeCircles {...dotsCoords} />
        <NodeCirclesExtended {...dotsCoords} />
    </>)
})
